import styled, { css } from 'styled-components';
import itemGlow from '~/assets/images/shop/item_glow.png';
import newShadow from '~/assets/images/shop/new_shadow.png';
import { WalletType } from '~/shared';
import { Text } from '../Text';
import { ShopItemProductVariant } from './ShopItemProduct.model';

const StyledNewDot = styled.div`
	position: relative;
	z-index: 1;
	width: 10px;
	min-width: 10px;
	height: 10px;
	border-radius: 10px;
	background: #ff3232;
`;

const StyledNewShadow = styled.div`
	position: absolute;
	top: -4px;
	left: 50%;
	transform: translateX(-50%);
	z-index: 0;
	width: 30px;
	height: 30px;
	background-image: url(${newShadow});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

const StyledTopContainer = styled.div`
	position: relative;
	z-index: 1;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 6px;

	${Text} {
		height: 18px;
		font-weight: 400;
		font-size: 16px;
		color: #ffffff;
		transition: color 0.3s ease;

		span {
			opacity: 0.5;
		}
	}
`;

const StyledPriceLabel = styled(Text)`
	font-weight: 400;
	font-size: 16px;
	color: #ffffff;
	opacity: 0.25;
	transition: color 0.3s ease;
`;

const StyledPrice = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

const StyledPriceContainer = styled.div<{ $variant: ShopItemProductVariant }>`
	position: absolute;
	bottom: 20px;
	z-index: 4;
	display: flex;
	align-items: center;
	gap: 10px;

	${({ $variant }) =>
		$variant === ShopItemProductVariant.Large
			? css`
					left: 20px;
					right: 20px;
					height: 16px;
					justify-content: space-between;
			  `
			: css`
					left: 50%;
					transform: translateX(-50%);
					justify-content: center;
			  `}

	${Text} {
		font-weight: 700;
		font-size: 16px;
		color: #ffffff;
		transition: color 0.3s ease;
	}

	${StyledPriceLabel} {
		font-weight: 400;
	}

	img {
		transition: filter 0.3s ease;
	}
`;

const StyledContainer = styled.div<{
	$selected?: boolean;
	$variant: ShopItemProductVariant;
	$walletType: WalletType;
}>`
	position: relative;
	padding: 17px 20px 18px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	cursor: pointer;
	transition:
		background-color 0.3s ease,
		border 0.3s ease;

	${({ $variant }) =>
		$variant === ShopItemProductVariant.Large
			? css`
					background-image: url(${itemGlow});
					background-repeat: no-repeat;
					background-size: 100% 100%;
					background-origin: border-box;
			  `
			: css`
					width: 185px;
					min-width: 185px;
					height: 185px;
					min-height: 185px;
			  `}

	& > img,
	& > .collection-spinner {
		display: block;
		margin: 15px auto 0;
	}

	&:hover {
		background-color: #ffffff;
		background-image: none;

		${StyledTopContainer} {
			${Text} {
				color: #000000;
			}
		}

		${StyledPriceContainer} {
			${Text} {
				color: #000000;
			}

			img {
				${(props) =>
					props.$walletType !== WalletType.Donate &&
					css`
						filter: invert(100%);
					`}
			}
		}
	}

	${(props) =>
		props.$selected &&
		css`
			background-color: #2d70da;
			border: 1px solid #2d70da;

			&:hover {
				background-color: #2d70da;
				border-color: #2d70da;
				background-image: ${props.$variant === ShopItemProductVariant.Large
					? `url(${itemGlow})`
					: 'none'};

				${StyledTopContainer} {
					${Text} {
						color: #ffffff;
					}
				}

				${StyledPriceContainer} {
					${Text} {
						color: #ffffff;
					}

					img {
						filter: none;
					}
				}
			}
		`}
`;

const StyledImageContainer = styled.div<{ $variant: ShopItemProductVariant }>`
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	z-index: 1;

	${({ $variant }) =>
		$variant === ShopItemProductVariant.Large
			? css`
					top: 61px;
					width: 120px;
					height: 120px;
			  `
			: css`
					top: 50px;
					width: 80px;
					height: 80px;
			  `}
`;

export {
	StyledContainer,
	StyledImageContainer,
	StyledNewDot,
	StyledNewShadow,
	StyledPrice,
	StyledPriceContainer,
	StyledPriceLabel,
	StyledTopContainer,
};
